import { styled } from "@mui/material";

interface ToolTipLegendCircleProps {
  color: string;
  border: string;
}

export const ToolTipLegendCircle = styled("span")<ToolTipLegendCircleProps>(
  ({ color, border }) => ({
    display: "inline-block",
    marginRight: "0.5rem",
    borderRadius: "50%",
    width: "0.75rem",
    height: "0.75rem",
    backgroundColor: color,
    border: `0.1rem solid ${border}`,
  })
);
